// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .section[data-v-775294f9]  .el-form-item__content {\n  width: 161px;\n}\n#app .section[data-v-775294f9]  .el-form-item__content .el-input-number {\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
